import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './numbered-pin.less';

const NumberedPin = ({
  showNumber,
  className,
  number,
  isSender,
  isRoundTrip = false,
  pointy = false,
}) => (
  <div
    className={cx(styles.pin, className, {
      [styles.numberBackground]: showNumber,
      [styles.roundTripDropoffBackground]: !isSender && isRoundTrip,
      [styles.dropoffBackground]: !isSender && !showNumber,
      [styles.pickupBackground]: isSender && !pointy,
      [styles.pointyPickupBackground]: isSender && pointy,
    })}
  >
    <span className={styles.pinNumber}> {showNumber ? number : <br />} </span>
  </div>
);

NumberedPin.defaultProps = {
  showNumber: false,
  small: false,
  number: 0,
  isSender: false,
  className: undefined,
  pointy: false,
  isRoundTrip: false,
};

NumberedPin.propTypes = {
  showNumber: PropTypes.bool,
  number: PropTypes.string,
  className: PropTypes.string,
  isSender: PropTypes.bool,
  pointy: PropTypes.bool,
  isRoundTrip: PropTypes.bool,
};

export default NumberedPin;
